import styled from 'styled-components';

const SpecialStyle = styled.section`
  width: 100%;
  padding-bottom: 40px;

  > div {
    flex-direction: column;
  }

  h2 {
    display: flex;
    color: #93da49;
    font-size: 120px;
    font-family: 'FeltThatW01-Regular';
    padding: 70px 0 0 0;
    justify-content: center;
    background-image: url(https://emprendeoboticario.com.co/wp-content/themes/twentytwenty-child/images/acuarela_productos.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 10%;
  }

  .BrainhubCarousel__arrows {
    background-color: transparent!important;

    span {
      display: none!important;
    }

    &:hover:enabled {
      background-color: transparent!important;
    }
  }

  .BrainhubCarousel__arrowLeft {
    background: url(https://emprendeoboticario.com.co/wp-content/themes/twentytwenty-child/images/left-arrow.svg) top center no-repeat transparent;
  }

  .BrainhubCarousel__arrowRight {
    background: url(https://emprendeoboticario.com.co/wp-content/themes/twentytwenty-child/images/right-arrow.svg) top center no-repeat transparent;
  }

  .BrainhubCarousel__dots {
    button {
      background: transparent;
    }
  }

  @media(max-width: 800px) {
    h2 {
      font-size: 65px;
      text-align: center;
    }
  }
`;

const SliderItem = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  h3 {
    font-size: 45px;
    font-weight: bold;
    color: #009f67;
    line-height: 1.33;
  }
  h4 {
    font-size: 45px;
    color: #007e78;
    font-family: 'FeltThatW01-Regular';
  }
  ul {
    margin-left: 15px;
    list-style: outside;
  }

  @media(max-width: 800px) {
    text-align: center;
    align-items: baseline;
    flex-direction: column;

    img {
      width: 100%;
    }

    h3 {
      font-size: 32px;
    }

    h4 {
      font-size: 30px;
      line-height: 28px;
      margin: 15px 0;
    }

    ul {
      padding: 0 10px;
      text-align: left;
    }
  }
`;

export { SpecialStyle, SliderItem };
